import { Grid, Typography, Box, Tabs, Tab, Divider } from "@mui/material";
import React, { useState } from "react";
import useHospitalAdd from "./useHospitalAdd";
import InsurancePage from "./Finance/Domestic/Insurance/InsurancePage";
import { checkPermission } from "../../../Utils/Permissions";
import InsuranceView from "./Finance/Domestic/Insurance/InsuranceView";
import { DetailTab } from "./DetailTab";
import FinanceTab from "./FinanceTab";
import { makeStyles } from "@mui/styles";
import Line from "../../../Components/Line";
import ToastMessage from "../../../Components/ToastMessage/ToastMessage";
import Journy from "../../../Components/Details.jsx/Journy";
import Edit from "../../../Assets/Icons/Edit";
import DisApproveModal from "../../../Components/ModalPopUp/DisApproveModal";
import ApproveModa from "../../../Components/ModalPopUp/ApproveModa";
import { DisApprove } from "../../../Assets/Icons/DisApprove";
import Rejection from "../../../Components/Details.jsx/Rejection";

const useStyles = makeStyles({
  tabs: {
    "& .MuiTabs-indicator": {
      backgroundColor: "transparent",
      height: 3,
    },
    "& .MuiTab-root.Mui-selected": {
      color: "white",
      backgroundColor: "#414851",
      borderRadius: "6px",
      minHeight: "35px",
      maxHeight: "35px",
      fontSize: "15px",
      fontFamily: "poppins",
      textTransform: "capitalize !important",
    },
    "& .css-1h9z7r5-MuiButtonBase-root-MuiTab-root": {
      textTransform: "capitalize !important",
      fontFamily: "poppins",
    },
  },
});

function HospitalAddPage() {
  const { doc, setDoc, ...state } = useHospitalAdd();
  const [approveModal, setApproveModal] = useState(false);
  const [disApproveModal, setDisApproveModal] = useState(false);
  const approve = () => {
    setApproveModal(!approveModal);
  };

  console.log("===================checkedItems=======", state?.isShow);

  const currentTab = "OPERATIONS";
  const department = state?.locationData?.department?.trim();
  const activeTab = department?.toUpperCase() === currentTab?.toUpperCase();

  const handleControl = (status) => {
    if (status === "REJECTED") {
      if (!state?.rejectedReason) {
        state?.setError(true);
      } else {
        setDisApproveModal(false);
        state?.setError(false);
      }
    } else if (status === "APPROVED") {
      setApproveModal(false);
    }
    state?.handleDisapprove(status);
  };

  const disSpprove = () => {
    setDisApproveModal(!disApproveModal);
  };

  const tabContents = [
    DetailTab(
      state,
      doc,
      setDoc,
      state.interdoc,
      state.setInterDoc,
      state.domDoc,
      state.setDomDoc,
      state.logo,
      state.setLogo,
      state.setInteriorImage,
      state.interiorImage,
      state.treatments,
      state.getTreatments
    ),
    FinanceTab(state),
    checkPermission("KARE_DB_INSURANCE_EDIT") ? (
      <InsurancePage
        hospitalId={state.id}
        locationData={state}
        tabName="INSURANCE"
      />
    ) : (
      <InsuranceView hospitalId={state.id} />
    ),
  ];

  const datas = [
    {
      id: 1,
      title: "Hospital Onboarding",
    },
    {
      id: 1,
      title: "Medical Head Approved",
    },
    {
      id: 1,
      title: "Finance Details Added",
    },
    {
      id: 1,
      title: "Finance Head Approved",
    },
    {
      id: 1,
      title: "Insurance Details Added",
    },
    {
      id: 1,
      title: "Insurance Head Approved",
    },
    {
      id: 1,
      title: "Ops Head Approved",
    },
    {
      id: 1,
      title: "Super Admin Approved",
    },
  ];

  const classes = useStyles();
  return (
    <Grid
      sx={{
        width: "77%",
        height: "95vh",
        padding: "0px 25px",
      }}
    >
      <Grid
        sx={{
          width: "100%",
          backgroundColor: "#f9fbfc",
          padding: "40px 40px 5px 40px",
        }}
      >
        <Grid lg={12} item container>
          <Grid lg={2}>
            <Typography
              sx={{ fontSize: "20px", fontWeight: "600", lineHeight: "60px" }}
            >
              {state.id ? state?.details?.name : "Add New Hospital"}
            </Typography>
          </Grid>
          <Grid lg={0.9}>
            <Line />
          </Grid>
          <Grid lg={3}>
            <div className="App">
              <Tabs
                className={classes.tabs}
                value={state.activeTab}
                onChange={state.handleTabChange}
                variant="standard"
                indicatorColor="transparent"
                TabScrollButtonProps={{
                  style: { backgroundColor: "black !important" },
                }}
              >
                <Tab
                  className={
                    state.activeTab === 0 ? "active-tab-button" : "tab-button"
                  }
                  label="Medical"
                />
                <Tab
                  className={
                    state.activeTab === 1 ? "active-tab-button" : "tab-button"
                  }
                  label="Finance"
                />
                {!state?.isShow && (
                  <Tab
                    className={
                      state.activeTab === 2 ? "active-tab-button" : "tab-button"
                    }
                    label="Insurance"
                  />
                )}
              </Tabs>
            </div>
          </Grid>

          {state?.currentStatus !== "Rejected" ? (
            <>
              {!(state?.isLive || state?.locationDatas?.addNew === true) && (
                <Grid lg={6}>
                  <Box display={"flex"} gap={1} justifyContent={"flex-end"}>
                    {checkPermission("KARE_DB_APROVAL") && (
                      <Box
                        component={"button"}
                        width={"140px"}
                        height={"36px"}
                        border={"solid 1px #66718A"}
                        bgcolor={"#F9FBFC"}
                        color={"#4C5A6A"}
                        fontSize={"14px"}
                        borderRadius={"8px"}
                        display={"flex"}
                        justifyContent={"center"}
                        alignItems={"center"}
                        gap={1}
                        sx={{
                          cursor: "pointer",
                        }}
                        onClick={approve}
                      >
                        <Box
                          display={"flex"}
                          justifyContent={"center"}
                          alignItems={"center"}
                        >
                          <Edit />
                        </Box>
                        <Typography>Approve</Typography>
                      </Box>
                    )}
                    {checkPermission("KARE_DB_APROVAL") && (
                      <Box
                        component={"button"}
                        width={"140px"}
                        height={"36px"}
                        border={"solid 1px #66718A"}
                        bgcolor={"#F9FBFC"}
                        color={"#4C5A6A"}
                        fontSize={"14px"}
                        borderRadius={"8px"}
                        display={"flex"}
                        justifyContent={"center"}
                        alignItems={"center"}
                        gap={1}
                        sx={{
                          cursor: "pointer",
                        }}
                        onClick={disSpprove}
                      >
                        <Box
                          display={"flex"}
                          justifyContent={"center"}
                          alignItems={"center"}
                        >
                          <Edit />
                        </Box>
                        <Typography>Disapprove</Typography>
                      </Box>
                    )}

                    {/* state?.currentStatus === "Pending" && */}
                    {/* <Box
                component={"button"}
                width={"100px"}
                height={"36px"}
                border={"solid 1px #66718A"}
                bgcolor={"#545E75"}
                color={"white"}
                fontSize={"14px"}
                borderRadius={"8px"}
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                gap={1}
                sx={{
                  cursor: "pointer",
                }}
               >
                <Box
                  display={"flex"}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  <Chat />
                </Box>
                <Typography>Chat</Typography>
              </Box> */}
                    {/* <Box
                  component={"button"}
                  width={"136px"}
                  height={"36px"}
                  border={"solid 1px #65DEC7"}
                  bgcolor={"#17DFBA"}
                  color={"white"}
                  fontSize={"14px"}
                  borderRadius={"8px"}
                  display={"flex"}
                  justifyContent={"center"}
                  alignItems={"center"} 
                  gap={1}
                  sx={{
                    cursor: "pointer",
                  }}
                >
                  <Box
                    display={"flex"}
                    justifyContent={"center"}
                    alignItems={"center"}
                    sx={{
                      cursor: "pointer",
                    }}
                  >
                    <Check />
                  </Box>
                  <Typography>Edit Details</Typography>
                </Box> */}
                  </Box>
                </Grid>
              )}
            </>
          ) : (
            <Grid lg={6} container justifyContent={"flex-end"}>
              <Box
                component={"button"}
                width={"150px"}
                height={"36px"}
                border={"solid 1px #f66c61"}
                bgcolor={"#f66c61"}
                color={"white"}
                fontSize={"14px"}
                borderRadius={"8px"}
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                gap={1}
                sx={{
                  cursor: "pointer",
                }}
              >
                <Box
                  display={"flex"}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  <DisApprove />
                </Box>
                <Typography>Disapproved</Typography>
              </Box>
            </Grid>
          )}
        </Grid>
        {/* <Divider /> */}
      </Grid>

      <Grid
        sx={{
          width: "100%",
          padding: " 0px 40px",
          height: "80vh",
          backgroundColor: "#f9fbfc",
          overflowX: "auto",
          "&::-webkit-scrollbar": {
            width: "10px",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "lightgray",
            visibility: "hidden",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            background: "gray",
          },
        }}
      >
        <Journy
          datas={datas}
          dataType={"CENTER"}
          state={state}
          tileId={state?.id}
        />

        {activeTab &&
          state?.activeTab === 0 &&
          state?.locationData?.rejectedReason && (
            <Rejection
              locationData={state}
              setIsEditable={state?.setIsEditable}
            />
          )}

        <Box className="tab-content">{tabContents[state.activeTab]}</Box>
      </Grid>
      <ToastMessage data={state?.state} setData={state?.setState} />
      <DisApproveModal
        handleControl={handleControl}
        disApproveModal={disApproveModal}
        setDisApproveModal={setDisApproveModal}
        setRejectedReason={state?.setRejectedReason}
        error={state?.error}
        rejectedReason={state?.rejectedReason}
      />

      <ApproveModa
        handleControl={handleControl}
        setApproveModal={setApproveModal}
        approveModal={approveModal}
      />
    </Grid>
  );
}

export default HospitalAddPage;
